import React from "react";

const PrivateLink = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M26 26h8v3.2h-4.8V34H26v-8ZM10 10H2V6.8h4.8V2H10v8Zm18.182 13.657-2.262-2.263 2.262-2.263A8 8 0 1 0 16.87 7.818l-2.263 2.262-2.263-2.262 2.263-2.263c4.374-4.374 11.465-4.374 15.84 0 4.373 4.374 4.373 11.465 0 15.84l-2.264 2.262Zm-4.525 4.525-2.263 2.263c-4.374 4.374-11.465 4.374-15.84 0-4.373-4.374-4.373-11.465 0-15.84l2.264-2.262 2.262 2.263-2.262 2.263A8 8 0 0 0 19.13 28.182l2.263-2.262 2.263 2.262Zm-1.132-16.97 2.263 2.263-11.313 11.313-2.263-2.263 11.313-11.313Z"
        />
    </svg>
);

export default PrivateLink;